// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import NumberFormatter from '../../../../i18n/numberformatter';
import theme from '../../../../styled-components/dark';
import { KLCollectibleRuleByCollectibleId } from '../../constants/labels';
import KLCollectibleBetslipDetailsCardContainer from '../../containers/KLOrientationStepDetailsCardContainer';
import { type KLCollectibleStatus, KLCollectibleStatuses, type KLCollectibleId } from '../../types/collectible';

const Wrapper = styled.div`
  width: 100%;
  border-radius: 0.6em;
  background: #1f1f1fcc;
  padding: 0.7em 1em;

  text-align: center;
  text-transform: uppercase;
  font-family: 'BettingArchivoNarrow';
`;

const Title = styled.div`
  font-size: 0.8em;
  margin-bottom: 0.7em;
`;

const RuleContent = styled.div`
  font-size: 1em;
  margin-bottom: 0.2em;

  b {
    color: ${theme.KLBadgeDetails.highlightColor};
    font-weight: inherit;
  }
`;

const RuleException = styled.div`
  font-size: 0.8em;
  margin-bottom: 0.9em;
`;

const OddWrapper = styled.div`
  font-size: 1em;
`;

const OddValue = styled.span`
  color: ${theme.KLBadgeDetails.highlightColor};
`;

const betslipDetailsAcceptedBadgeStatus = [
  KLCollectibleStatuses.WON,
  KLCollectibleStatuses.PENDING,
  KLCollectibleStatuses.LOST,
  KLCollectibleStatuses.CANCELLED,
];

type KLBadgeDetailsCardProps = {
  className?: string;
  badgeId: KLCollectibleId;
  status: KLCollectibleStatus;
  betslipReference?: string;
  minOdds?: number;
};

const KLBadgeDetailsCard = ({ className, badgeId, status, betslipReference, minOdds }: KLBadgeDetailsCardProps) => {
  const collectibleRule = useMemo(() => KLCollectibleRuleByCollectibleId[badgeId] ?? {}, [badgeId]);
  const formattedMinOdds = useMemo(() => (minOdds ? NumberFormatter.formatOdd(minOdds) : undefined), [minOdds]);

  const shouldDisplayBetslipDetails = useMemo(() => {
    return betslipReference && betslipDetailsAcceptedBadgeStatus.indexOf(status) !== -1;
  }, [betslipReference, status]);

  return shouldDisplayBetslipDetails ? (
    <KLCollectibleBetslipDetailsCardContainer
      className={className}
      betslipReference={betslipReference}
      status={status}
    />
  ) : (
    <Wrapper className={className}>
      <Title>Type de pari à gagner :</Title>
      <>
        <RuleContent>{collectibleRule.rule}</RuleContent>
        <RuleException>{collectibleRule.exception}</RuleException>
        <OddWrapper>
          Cote mini : <OddValue>{formattedMinOdds}</OddValue>
        </OddWrapper>
      </>
    </Wrapper>
  );
};

export default KLBadgeDetailsCard;
